/*! ******************************************************************************************************** *
 *
 * Copyright 2011-2020 Markus Schütz
 * Copyright 2025 Oidis
 *
 * SPDX-License-Identifier: BSD-2-Clause
 * The BSD-2-Clause license for this file can be found in the LICENSE.txt file included with this distribution
 * or at https://spdx.org/licenses/BSD-2-Clause.html#licenseText
 *
 * ********************************************************************************************************* */

let ftCanvas = document.createElement("canvas");

export const Features = (function () {
    let gl = ftCanvas.getContext("webgl") || ftCanvas.getContext("experimental-webgl");
    if (gl === null) {
        return null;
    }

    let _vertexShaderPrecisionHighpFloat = gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT);
    let _vertexShaderPrecisionMediumpFloat = gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT);

    let _fragmentShaderPrecisionHighpFloat = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT);
    let _fragmentShaderPrecisionMediumpFloat = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT);

    let highpAvailable = _vertexShaderPrecisionHighpFloat.precision > 0 && _fragmentShaderPrecisionHighpFloat.precision > 0;
    let mediumpAvailable = _vertexShaderPrecisionMediumpFloat.precision > 0 && _fragmentShaderPrecisionMediumpFloat.precision > 0;

    let precision;
    if (highpAvailable) {
        precision = "highp";
    } else if (mediumpAvailable) {
        precision = "mediump";
    } else {
        precision = "lowp";
    }

    return {
        SHADER_INTERPOLATION: {
            isSupported: function () {
                let supported = true;

                supported = supported && gl.getExtension("EXT_frag_depth");
                supported = supported && gl.getParameter(gl.MAX_VARYING_VECTORS) >= 8;

                return supported;
            }
        },
        SHADER_SPLATS: {
            isSupported: function () {
                let supported = true;

                supported = supported && gl.getExtension("EXT_frag_depth");
                supported = supported && gl.getExtension("OES_texture_float");
                supported = supported && gl.getParameter(gl.MAX_VARYING_VECTORS) >= 8;

                return supported;
            }
        },
        SHADER_EDL: {
            isSupported: function () {
                let supported = true;

                supported = supported && gl.getExtension("EXT_frag_depth");
                supported = supported && gl.getExtension("OES_texture_float");
                supported = supported && gl.getParameter(gl.MAX_VARYING_VECTORS) >= 8;

                return supported;
            }
        },
        precision: precision
    };
}());
